import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Button, Error, Label } from 'shared/ui'
import { ChatbotEnrollModalSearch } from 'widgets/ChatbotEnroll/ui/ChatbotEnrollModalSearch'
import { type AICallingAgentStore } from '../../store/AICallingAgentStore'
import { createAICallingAgentEnrollSearchStore } from './AICallingAgentEnrollSearchStore'
import styles from './styles.module.scss'

type IAICallingAgentActionEditContentProps = {
  store: AICallingAgentStore
}

export const AICallingAgentActionEditContent = observer(
  ({ store }: IAICallingAgentActionEditContentProps) => {
    const { setAiCallingAgent, aiCallingAgent, aiCallingAgentError, openNewAgentModal } = store
    const searchStore = useMemo(() => createAICallingAgentEnrollSearchStore(), [])

    return (
      <div className={styles.wrap}>
        <div className={styles.field}>
          <Label label={{ text: 'Agent name' }} />
          <ChatbotEnrollModalSearch
            onSelect={setAiCallingAgent}
            textFieldProps={{
              error: aiCallingAgentError,
              className: styles.textField,
            }}
            selectedItem={aiCallingAgent}
            searchStore={searchStore}
            renderDropdownFooter={(closeDropdown) => (
              <Button
                text='New AI Calling Agent'
                icon='add'
                typeBtn='menuItem'
                size='medium'
                onClick={() => openNewAgentModal(closeDropdown)}
              />
            )}
          />
          {!!aiCallingAgentError && <Error type={'text'} error={aiCallingAgentError} />}
        </div>
      </div>
    )
  }
)
